import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { CoinCardComponent } from './cards/coin-card/coin-card.component';
import { ProfileCardComponent } from './cards/profile-card/profile-card.component';
import { FormsModule } from '@angular/forms';
import { NgMagnizoomModule } from 'ng-magnizoom';
import { AdvanceFiltersComponent } from './advance-filters/advance-filters.component';
const ComponentsList = [
  NavbarComponent,CoinCardComponent,ProfileCardComponent,AdvanceFiltersComponent
]


@NgModule({
  declarations: [ComponentsList],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    NgMagnizoomModule
  ],
  exports:[
    ComponentsList
  ]
})
export class ComponentsModule { }
